export default __webpack_public_path__ + "static/media/img-merchant-wallet-app-banner-mobile.e720266c.png";